import { Attachment as AttachmentDto } from "@/lib/types";
import { Attachment } from "./attachment";
import axios from "axios";

const API_URL = import.meta.env.VITE_BACK_URL;
const CONV_URL = import.meta.env.VITE_CONVERTISSEUR_URL;

export async function uploadImage(
  file: File,
  data: AttachmentDto,
  s3Bucket: string,
  instanceId: string,
  url?: string,
  displayName?: string,
): Promise<Attachment> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", data.name);
  formData.append("position", data.position);
  formData.append("legend", data.legend || "");
  formData.append("legendEN", data.legendEN || "");
  formData.append("details", data.details || "");
  formData.append("docId", data.docId);
  formData.append("order", data.order?.toString() || "-1");
  formData.append("published", data.published ? "true" : "false");
  formData.append("descriptionFR", data.descriptionFR || "");
  formData.append("descriptionEN", data.descriptionEN || "");
  formData.append("textAltFR", data.textAltFR || data.name || "");
  formData.append("textAltEN", data.textAltEN || "");
  formData.append("S3_BUCKET", s3Bucket);
  formData.append("instanceId", instanceId);
  formData.append("isHd", data.isHd ? "true" : "false");

  if (data.caption) formData.append("caption", JSON.stringify(data.caption));
  if (data.textAlt) formData.append("textAlt", JSON.stringify(data.textAlt));
  if (data.description)
    formData.append("description", JSON.stringify(data.description));
  if (displayName) formData.append("displayName", displayName);

  if (!url) {
    formData.append("API_URL", API_URL + "back/api/attachment/create/unique");
  } else {
    formData.append("API_URL", API_URL + url);
  }

  const response = await axios.post(CONV_URL + "uploadV3", formData);
  return response.data.image;
}

export interface FileUpload {
  sourceName: string;
  title: string;
  tag: string;
  docId: string;
  isHd?: boolean;
  mimetype: string;
  description?: string;
  instanceId?: string;
}

export async function uploadDocument(
  file: File,
  s3bucket: string,
  data: FileUpload,
) {
  const formData = new FormData();
  formData.append("doc", file);
  formData.append("S3_BUCKET", s3bucket);
  formData.append("sourceName", data.sourceName);
  formData.append("title", data.title);
  formData.append("tag", data.tag);
  formData.append("description", data.description ?? "");
  formData.append("docId", data.docId);
  formData.append("mimetype", data.mimetype);
  formData.append("API_URL", API_URL + "back/api/file/create");
  if (data.instanceId) {
    formData.append("instanceId", data.instanceId);
  }

  try {
    await axios.post(CONV_URL + "uploadV3/document", formData);
  } catch (e) {
    console.error(e);
  }
}
